export enum StatiUtenteApplicativo {
  InBozza = 1,
  InAttesaAttivazione = 2,
  Attivo = 3,
  AttivoConModificheInBozza = 4,
  AttivoInAttesaConfermaModifiche = 5,
  AttivazioneNonRiuscita = 6,
  IntegrazioneInCorso = 7,
  InvioMailInCorso = 8,
  InAttesaConfermaEmail = 9,
  EmailNonConfermata = 10,
  ErroreInvioEmail = 11,
}
